import { KEEP_ALIVE_OBJECT } from '@/common/constants/ConstCode';

export default [
  {
    path: '/memorial',
    component: () => import('@/views/memorial/'),
    meta: {
      isHeader: false,
      isNav: true,
      isBack: true,
      titleName: '',
      subName: '추모관',
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression,
      isSearchHeader: true,
      isFilter: true
    }
  },
  {
    path: '/memorial/select',
    component: () => import('@/views/memorial/select.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '추모관 선택',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_SELECT.expression
    }
  },
  {
    path: '/memorial/select/register',
    component: () => import('@/views/memorial/select.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '추모관 선택',
      isSearchHeader: false
    }
  },
  {
    path: '/memorial/register/form/ticket',
    component: () => import('@/views/memorial/register/step1.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },
  {
    path: '/memorial/register/form/information',
    component: () => import('@/views/memorial/register/step2.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isHome: true,
      isBack: true,
      titleName: '',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },
  {
    path: '/memorial/register/form/anniversary',
    component: () => import('@/views/memorial/register/step3.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },
  {
    path: '/memorial/register/form/background',
    component: () => import('@/views/memorial/register/step4.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },

  {
    path: '/memorial/register/form/background/preview',
    component: () => import('@/views/memorial/register/MemorialBackgroundPreView.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '미리보기'
    }
  },

  {
    path: '/memorial/register/form/gallery',
    component: () => import('@/views/memorial/register/MemorialGallery.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },

  {
    path: '/memorial/church/:churchNo',
    component: () => import('@/views/memorial/churchList.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      subName: '추모관',
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression,
      isSearchHeader: false,
      isFilter: false
    }
  },
  {
    path: '/memorial/:memorialNo',
    component: () => import('@/views/memorial/MemorialDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '',
      isGlass: true,
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression
    }
  },
  {
    // 추모관 등록/수정 후 상세 페이지로 이동
    path: '/memorial/info/:memorialNo',
    component: () => import('@/views/memorial/MemorialDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '',
      isGlass: true,
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression
    }
  },
  {
    path: '/memorial/wreath/:memorialNo',
    component: () => import('@/views/memorial/wreathDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '',
      isGlass: true,
      isSearchHeader: false,
      isMemorialShare: true,
      isMemorialKakaoShare: true,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression
    }
  },
  {
    path: '/memorial/history/:familyCode',
    component: () => import('@/views/memorial/history/index.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '우리가족 히스토리',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression
    }
  },
  {
    path: '/memorial/alive/:memorialNo',
    component: () => import('@/views/memorial/alive/AliveIndex.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '생전모습 모아보기',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression
    }
  },

  {
    path: '/memorial/alive/register/:memorialNo',
    component: () => import('@/views/memorial/alive/register.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '생전모습 등록하기',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression
    }
  },
  {
    path: '/memorial/alive/update/:aliveNo',
    component: () => import('@/views/memorial/alive/register.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '생전모습 수정하기',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression
    }
  },

  {
    path: '/memorial/alive/detail/:aliveNo',
    component: () => import('@/views/memorial/alive/detail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '생전모습',
      isGlass: false,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression
    }
  },
  {
    path: '/memorial/wreath/chat/:no',
    component: () => import('@/views/memorial/chat.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '추모하기',
      isGlass: false,
      isMemorialShare: true,
      expression: KEEP_ALIVE_OBJECT.MEMORIAL.expression
    }
  }
];
